import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
// import { file } from 'app/admin/view-mis/refno';
import { ApplicantService } from 'app/laas/applicant.service';

@Component({
  selector: 'wl-file-download-modal',
  templateUrl: './file-download-modal.component.html',
  styleUrls: ['./file-download-modal.component.css']
})
export class FileDownloadModalComponent implements OnInit {

  @Input() applicantId: string;
  contentText: string;
  files: [] = [];
  loading: boolean;
  @Output() close = new EventEmitter<void>();

  constructor(private applicant: ApplicantService, private snackbar: MatSnackBar) { }

  ngOnInit() {

    this.loading = true;
    this.applicant.getFilesList(this.applicantId).subscribe((resp) => {
      this.loading = false;
      console.log(resp);
      if (resp && resp.status) {
        if (resp.data.names && resp.data.names.length) {
          //show list
          this.files = resp.data.names;
        } else {
          this.contentText = "No files uploaded";
        }
      }
    }, (err) => {
      this.loading = false;
      this.snackbar.open("Failed to download file", "OK", { duration: 3000 })
    })

  }

  downloadFiles(filename) {
    this.loading = true;
    this.applicant.downloadFile(this.applicantId, filename).subscribe((resp) => {
      console.log(resp);
      this.loading = false;
      if (resp && resp.status) {
        if (resp.data) {
          this.saveFile(resp.data,filename);
        }else{
          this.snackbar.open("No file found.","OK",{duration:3000})
        }
      }
    })
  }

  saveFile(buffer: ArrayBuffer, fileName: string) {
    const blob = new Blob([buffer], { type: 'application/pdf' }); // Adjust MIME type as needed
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    window.URL.revokeObjectURL(url);
  }

  closeComponent() {
    this.close.emit();
  }
}
